import { createStyles, makeUiStyles, Theme } from '../../../styles/styles';
import { fontDisplay, fontText, StylesIndexInjections } from 'common-react';
import { focusStyle } from '../../../styles/mixins';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {},
  wrapper: {
    height: 'calc(100% - 48px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    font: fontDisplay('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    border: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: '24px 0',

    '&:hover, &:focus': {
      outline: 'none',
      border: 'none'
    },

    '&:focus-visible': {
      ...focusStyle(theme)
    }
  },
  arrowIcon: {
    color: theme.color.greys[80],
    marginLeft: 4,
  },
  checkBoxWrapper: {
    margin: 0,
    padding: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.color.greys[10]}`
  },
  checkBox: {
    cursor: 'pointer',
    padding: '16px 0',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  label: {
    cursor: 'pointer',
    padding: '16px 0',
    display: 'block',
    width: '100%',
    font: fontText('normal', theme.fontSize.base, 20),
    color: theme.color.greys[80],
  },
  list: {
    listStyle: 'none',
    margin: '16px 0 0',
    padding: 0
  },
  filterTitle: {
    marginBottom: 24,
  },
  checkBoxIcon: {
    '& path': {
      stroke: theme.color.greys[20]
    }
  },
  buttonLabelValueWrapper: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  }
}), { name: 'CheckboxesModalList', index: StylesIndexInjections.UI_MOLECULES });
